import { render, staticRenderFns } from "./DialogStatus.vue?vue&type=template&id=b160f306&scoped=true&"
import script from "./DialogStatus.vue?vue&type=script&lang=js&"
export * from "./DialogStatus.vue?vue&type=script&lang=js&"
import style0 from "./DialogStatus.vue?vue&type=style&index=0&id=b160f306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b160f306",
  null
  
)

export default component.exports